import React from "react";

import { SectionBasicInfoList } from "./section-basic-info-list";
import { SectionTitle } from "./section-title";

interface EnrollmentAndZoningProps {
  attendingSchool: string;
  districtOfResidence: string;
  newToDistrict: string;
  residenceES: string;
  residenceMS: string;
  residenceHS: string;
}

export const EnrollmentAndZoning: React.FC<EnrollmentAndZoningProps> = ({
  attendingSchool,
  districtOfResidence,
  newToDistrict,
  residenceES,
  residenceMS,
  residenceHS,
}) => {
  return (
    <div>
      <SectionTitle title="Enrollment & Zoning" />

      <SectionBasicInfoList
        items={[
          { type: "text", head: "Attending School", value: attendingSchool || "--" },
          {
            type: "text",
            head: "District of Residence",
            value: districtOfResidence || "--",
          },
          { type: "badge", head: "New to District", value: newToDistrict || "--" },
          { type: "text", head: "Residence ES", value: residenceES || "--" },
          { type: "text", head: "Residence MS", value: residenceMS || "--" },
          { type: "text", head: "Residence HS", value: residenceHS || "--" },
        ]}
      />
    </div>
  );
};